import { RequestService } from '../../../../common/services/RequestService';
import { UPDATE_VEHICLE } from '../constants';
import { adjustUpdateVehicleStatusResponse } from './dataAdjustment';

export const updateVehicleStatusRequest = async (
  profileId,
  vehicleId,
  status
) => {
  const response = await RequestService.put(
    UPDATE_VEHICLE.replace("{profile_id}", profileId).replace(
      "{vehicle_id}",
      vehicleId
    ),
    {
      vehicle_status_id: status
    }
  );
  return response.data && adjustUpdateVehicleStatusResponse(response.data);
};
